import world from './world.json'
import { transformCountries } from '../../helpers/country'

const countries = transformCountries(world)

export default countries
